import styled from '@emotion/styled'

import { focusVisible } from '@/styles/mixins'

export const LinkWrapper = styled.a`
  ${focusVisible};
  display: flex;
`
